// extracted by mini-css-extract-plugin
export var logo = "_4l-2";
export var logoWrapper = "_4l-1";
export var strip = "_4l-0";